import ComponentName from '../constant/ComponentName';

export const getComponentIcon = (component: ComponentName): string => {
  switch (component) {
    case ComponentName.TRANSACTION:
      return 'sidebar-channel';
    case ComponentName.ENTITY:
      return 'sidebar-entity';
    case ComponentName.STREAM:
      return 'sidebar-store';
    case ComponentName.LIST:
      return 'sidebar-list';
    case ComponentName.ENRICHMENT:
      return 'sidebar-enrichment';
    case ComponentName.RULE:
      return 'sidebar-rule';
    case ComponentName.CONNECTION:
      return 'sidebar-connection';
    case ComponentName.STRUCT:
      return 'sidebar-struct';
    case ComponentName.ACTION:
      return 'sidebar-action';
    case ComponentName.SANDBOX:
      return 'sidebar-sandbox';
    case ComponentName.ADMINISTRATION:
      return 'sidebar-administration';
    case ComponentName.CONFIGURATION:
      return 'sidebar-settings';
    case ComponentName.DASHBOARD:
      return 'sidebar-dashboard';
    case ComponentName.GRAPH:
      return 'sidebar-graph';
    case ComponentName.CASE:
      return 'sidebar-transaction';
    case ComponentName.WATCHLIST:
      return 'sidebar-watchlist';
    case ComponentName.CUSTOM_LIST:
      return 'customlisticon';
    case ComponentName.WATCHLIST_ALERT:
      return 'sidebar-alert';
    case ComponentName.AI_MODEL:
      return 'sidebar-ai';
    case ComponentName.TRACKER:
      return "sidebar-tracker";
    case ComponentName.POLICY:
      return "sidebar-policy";
    case ComponentName.ASSESSMENT:
      return "sidebar-assessment";
    case ComponentName.ACH:
      return 'sidebar-ach';
    default:
      return 'error';
  }
};
